<template>
  <div id="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <v-app>
      <v-dialog scrollable v-model="loginDialog" max-width="600px">
        <!-- <template v-slot:activator="{ on, attrs }">
    <v-btn color="green" v-on="on" v-bind="attrs" class="ma-4 elevation-4"
      >Add Values</v-btn
    >
  </template> -->
        <v-card>
          <v-card-title>
            <span class="headline">Déconnecté</span>
          </v-card-title>
          <v-card-text>
            <p>Vous avez été déconnecter, veuillez vous reconnecter</p>
            <v-form ref="form">
              <!-- <v-text-field v-model="name" label="Nom"></v-text-field>
        <v-text-field v-model="taille" label="Taille"></v-text-field>
        <v-text-field v-model="origine" label="Origine"></v-text-field>
        <v-text-field v-model="age" label="age"></v-text-field> -->
              <v-text-field
                v-model="password"
                label="Mot de passe"
                :type="'password'"
              ></v-text-field>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green" text @click="login()">Connection</v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <div class="mt-4">
        <v-text-field
          v-model="search"
          outlined
          class="ma-4"
          label="Recherche"
        ></v-text-field>
      </div>

      <v-btn @click="UpdateData()" color="blue" class="ma-4 elevation-4">
        <v-icon>mdi-cached</v-icon>
      </v-btn>
      <v-btn v-on:click="deleteSelected" color="error" class="ma-4 elevation-4"
        >Delete Values</v-btn
      >
      <v-dialog scrollable v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="green" v-on="on" v-bind="attrs" class="ma-4 elevation-4"
            >Add Values</v-btn
          >
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Add Values</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <!-- <v-text-field v-model="name" label="Nom"></v-text-field>
              <v-text-field v-model="taille" label="Taille"></v-text-field>
              <v-text-field v-model="origine" label="Origine"></v-text-field>
              <v-text-field v-model="age" label="age"></v-text-field> -->
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="matricule"
                  label="Matricule"
                ></v-text-field>
                <v-text-field
                  v-model="nom_usuel"
                  label="Nom usuel"
                ></v-text-field>
                <v-text-field
                  v-model="nom_patronymique"
                  label="Nom patronymique"
                ></v-text-field>
                <v-text-field v-model="prenom" label="Prénom"></v-text-field>
                <v-text-field
                  v-model="grade"
                  label="Grade/metier/fonction"
                ></v-text-field>
                <v-text-field v-model="echelon" label="Échelon"></v-text-field>
                <v-text-field
                  v-model="type_contrat"
                  label="Type contrat"
                ></v-text-field>
                <v-text-field
                  v-model="au_tableau_emplois"
                  label="Au tableau des emplois"
                ></v-text-field>
                <v-text-field
                  v-model="date_debut"
                  label="Date debut"
                ></v-text-field>
                <v-text-field
                  v-model="date_fin"
                  label="Date fin"
                ></v-text-field>
                <v-text-field v-model="n1" label="N1"></v-text-field>
                <v-text-field
                  v-model="quotite_travail"
                  label="Quotité de travail (%)"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="projet1"
                  label="Projet 1 (Source de finacement)"
                ></v-text-field>
                <v-text-field
                  v-model="ventilation1"
                  label="Ventilation 1 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="cout_ventile1"
                  label="Coût employeur ventilé 1"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="projet2"
                  label="projet 2 (source de financement)"
                ></v-text-field>
                <v-text-field
                  v-model="ventilation2"
                  label="Ventilation 2 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="cout_ventile2"
                  label="Coût employeur ventilé 2"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="projet3"
                  label="projet 3 (source de financement)"
                ></v-text-field>
                <v-text-field
                  v-model="ventilation3"
                  label="Ventilation 3 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="cout_ventile3"
                  label="Coût employeur ventilé 3"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="projet4"
                  label="projet 4 (source de financement)"
                ></v-text-field>
                <v-text-field
                  v-model="ventilation4"
                  label="Ventilation 4 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="cout_ventile4"
                  label="Coût employeur ventilé 4"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="projet5"
                  label="projet 5 (source de financement)"
                ></v-text-field>
                <v-text-field
                  v-model="ventilation5"
                  label="Ventilation 5 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="cout_ventile5"
                  label="Coût employeur ventilé 5"
                ></v-text-field>
              </v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false"
                  >Fermer</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="
                    dialog = false;
                    AddData();
                  "
                  >Ajouter</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog scrollable v-model="editDialog" max-width="600px">
        <!-- <template v-slot:activator="{ on, attrs }">
          <v-btn color="green" v-on="on" v-bind="attrs" class="ma-4 elevation-4"
            >Add Values</v-btn
          >
        </template> -->
        <v-card>
          <v-card-title>
            <span class="headline">Modifier</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <!-- <v-text-field v-model="editName" label="Nom"></v-text-field>
              <v-text-field v-model="editTaille" label="Taille"></v-text-field>
              <v-text-field v-model="editOrigine" label="Origine"></v-text-field>
              <v-text-field v-model="editAge" label="age"></v-text-field> -->
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="editmatricule"
                  label="Matricule"
                ></v-text-field>
                <v-text-field
                  v-model="editnom_usuel"
                  label="Nom usuel"
                ></v-text-field>
                <v-text-field
                  v-model="editnom_patronymique"
                  label="Nom patronymique"
                ></v-text-field>
                <v-text-field
                  v-model="editprenom"
                  label="Prénom"
                ></v-text-field>
                <v-text-field
                  v-model="editgrade"
                  label="Grade/metier/fonction"
                ></v-text-field>
                <v-text-field
                  v-model="editechelon"
                  label="Échelon"
                ></v-text-field>
                <v-text-field
                  v-model="edittype_contrat"
                  label="Type contrat"
                ></v-text-field>
                <v-text-field
                  v-model="editau_tableau_emplois"
                  label="Au tableau des emplois"
                ></v-text-field>
                <v-text-field
                  v-model="editdate_debut"
                  label="Date debut"
                ></v-text-field>
                <v-text-field
                  v-model="editdate_fin"
                  label="Date fin"
                ></v-text-field>
                <v-text-field v-model="editn1" label="N1"></v-text-field>
                <v-text-field
                  v-model="editquotite_travail"
                  label="Quotité de travail (%)"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="editprojet1"
                  label="Projet 1 (Source de finacement)"
                ></v-text-field>
                <v-text-field
                  v-model="editventilation1"
                  label="Ventilation 1 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="editcout_ventile1"
                  label="Coût employeur ventilé 1"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="editprojet2"
                  label="projet 2 (source de financement)"
                ></v-text-field>
                <v-text-field
                  v-model="editventilation2"
                  label="Ventilation 2 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="editcout_ventile2"
                  label="Coût employeur ventilé 2"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="editprojet3"
                  label="projet 3 (source de financement)"
                ></v-text-field>
                <v-text-field
                  v-model="editventilation3"
                  label="Ventilation 3 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="editcout_ventile3"
                  label="Coût employeur ventilé 3"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="editprojet4"
                  label="projet 4 (source de financement)"
                ></v-text-field>
                <v-text-field
                  v-model="editventilation4"
                  label="Ventilation 4 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="editcout_ventile4"
                  label="Coût employeur ventilé 4"
                ></v-text-field>
              </v-card>
              <v-card class="pa-3 my-2 elevation-5">
                <v-text-field
                  v-model="editprojet5"
                  label="projet 5 (source de financement)"
                ></v-text-field>
                <v-text-field
                  v-model="editventilation5"
                  label="Ventilation 5 (%)"
                ></v-text-field>
                <v-text-field
                  v-model="editcout_ventile5"
                  label="Coût employeur ventilé 5"
                ></v-text-field>
              </v-card>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="syncEdited()"
                  >Reset</v-btn
                >
                <v-btn color="blue darken-1" text @click="editDialog = false"
                  >Fermer</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="
                    editDialog = false;
                    EditItem();
                  "
                  >Modifier</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Data table -->
      <v-data-table
        show-expand
        loading="true"
        v-model="selected"
        show-select
        :headers="headers"
        :items="table"
        item-key="_id"
        :search="search"
        :items-per-page="100"
        :footer-props="{
          itemsPerPageOptions: [10, 100, 400],
        }"
        class="elevation-5 ma-5"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-container>
              <v-row>
                <v-col>
                  <!-- First card -->
                  <v-card class="ma-2">
                    <v-card-title>
                      {{ item.projet1 }}
                    </v-card-title>
                    <v-card-text>
                      <v-card class="ma-2">
                        <v-card-title>
                          Ventilation 1
                        </v-card-title>
                        <v-card-text>
                          {{ item.ventilation1 }}
                        </v-card-text>
                      </v-card>
                      <v-card class="ma-2">
                        <v-card-title>
                          Cout Ventilation 1
                        </v-card-title>
                        <v-card-text>
                          {{ item.cout_ventile1 }}
                        </v-card-text>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <!-- Second card -->
                  <v-card class="ma-2">
                    <v-card-title>
                      {{ item.projet2 }}
                    </v-card-title>
                    <v-card-text>
                      <v-card class="ma-2">
                        <v-card-title>
                          Ventilation 2
                        </v-card-title>
                        <v-card-text>
                          {{ item.ventilation2 }}
                        </v-card-text>
                      </v-card>
                      <v-card class="ma-2">
                        <v-card-title>
                          Cout Ventilation 2
                        </v-card-title>
                        <v-card-text>
                          {{ item.cout_ventile2 }}
                        </v-card-text>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <!-- Third card -->
                  <v-card class="ma-2">
                    <v-card-title>
                      {{ item.projet3 }}
                    </v-card-title>
                    <v-card-text>
                      <v-card class="ma-2">
                        <v-card-title>
                          Ventilation 3
                        </v-card-title>
                        <v-card-text>
                          {{ item.ventilation3 }}
                        </v-card-text>
                      </v-card>
                      <v-card class="ma-2">
                        <v-card-title>
                          Cout Ventilation 3
                        </v-card-title>
                        <v-card-text>
                          {{ item.cout_ventile3 }}
                        </v-card-text>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <!-- Fourth card -->
                  <v-card class="ma-2">
                    <v-card-title>
                      {{ item.projet4 }}
                    </v-card-title>
                    <v-card-text>
                      <v-card class="ma-2">
                        <v-card-title>
                          Ventilation 4
                        </v-card-title>
                        <v-card-text>
                          {{ item.ventilation4 }}
                        </v-card-text>
                      </v-card>
                      <v-card class="ma-2">
                        <v-card-title>
                          Cout Ventilation 4
                        </v-card-title>
                        <v-card-text>
                          {{ item.cout_ventile4 }}
                        </v-card-text>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <!-- Fifth card -->
                  <v-card class="ma-2">
                    <v-card-title>
                      {{ item.projet5 }}
                    </v-card-title>
                    <v-card-text>
                      <v-card class="ma-2">
                        <v-card-title>
                          Ventilation 5
                        </v-card-title>
                        <v-card-text>
                          {{ item.ventilation5 }}
                        </v-card-text>
                      </v-card>
                      <v-card class="ma-2">
                        <v-card-title>
                          Cout Ventilation 5
                        </v-card-title>
                        <v-card-text>
                          {{ item.cout_ventile5 }}
                        </v-card-text>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="
              editDialog = true;
              modifiingItem = item;
            "
          >
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <!-- End Data table -->
      <!-- <button v-on:click="getTable">Saltut</button>
      <button v-on:click="add">add</button>
      <button v-on:click="printSelected">print Values</button>
      <ul>
        <li v-for="i in table" v-bind:key="i._id">
          <p>{{ i.name }}</p>
          <p>{{ i.age }}</p>
        </li>
      </ul>
      <h2>{{ table }}</h2> -->
    </v-app>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import AddForm from '@/components/AddForm.vue'

let apiUrl = "https://gestionserver.ait-younes.fr:3000";

export default {
  name: "Home",
  // components: {
  //   AddForm
  // },
  // components: {
  //   HelloWorld
  // }
  data: () => {
    return {
      table: [],
      search: "",
      headers: [
        // { text: "name", align: "start", value: "name" },
        // { text: "age", value: "age" },
        // { text: "taille", value: "taille" },
        // { text: "origine", value: "origine" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "Matricule", align: "start", value: "matricule" },
        { text: "Nom usuel", value: "nom_usuel" },
        { text: "Nom patronymique", value: "nom_patronymique" },
        { text: "Prénom", value: "prenom" },
        { text: "Grade/metier/fonction", value: "grade" },
        { text: "Échelon", value: "echelon" },
        { text: "Type contrat", value: "type_contrat" },
        { text: "Au tableau des emplois", value: "au_tableau_emplois" },
        { text: "Date debut", value: "date_debut" },
        { text: "Date fin", value: "date_fin" },
        { text: "N1", value: "n1" },
        { text: "Quotité de travail (%)", value: "quotite_travail" },
        // { text: "Projet 1 (Source de finacement)", value: "projet1" },
        // { text: "Ventilation 1 (%)", value: "ventilation1" },
        // { text: "Coût employeur ventilé 1", value: "cout_ventile1" },
        // { text: "projet 2 (source de financement)", value: "projet2" },
        // { text: "Ventilation 2 (%)", value: "ventilation2" },
        // { text: "Coût employeur ventilé 2", value: "cout_ventile2" },
        // { text: "projet 3 (source de financement)", value: "projet3" },
        // { text: "Ventilation 3 (%)", value: "ventilation3" },
        // { text: "Coût employeur ventilé 3", value: "cout_ventile3" },
        // { text: "projet 4 (source de financement)", value: "projet4" },
        // { text: "Ventilation 4 (%)", value: "ventilation4" },
        // { text: "Coût employeur ventilé 4", value: "cout_ventile4" },
        // { text: "projet 5 (source de financement)", value: "projet5" },
        // { text: "Ventilation 5 (%)", value: "ventilation5" },
        // { text: "Coût employeur ventilé 5", value: "cout_ventile5" },
      ],
      selected: [],
      dialog: false,
      editDialog: false,
      loginDialog: false,
      password: "",
      modifiingItem: {},
      // name: "",
      // taille: "",
      // origine: "",
      // age: "",
      // editName: "",
      // editTaille: "",
      // editOrigine: "",
      // editAge: "",
      matricule: "",
      nom_usuel: "",
      nom_patronymique: "",
      prenom: "",
      grade: "",
      echelon: "",
      type_contrat: "",
      au_tableau_emplois: "",
      date_debut: "",
      date_fin: "",
      n1: "",
      quotite_travail: "",
      projet1: "",
      ventilation1: "",
      cout_ventile1: "",
      projet2: "",
      ventilation2: "",
      cout_ventile2: "",
      projet3: "",
      ventilation3: "",
      cout_ventile3: "",
      projet4: "",
      ventilation4: "",
      cout_ventile4: "",
      projet5: "",
      ventilation5: "",
      cout_ventile5: "",
      // Edit now
      editmatricule: "",
      editnom_usuel: "",
      editnom_patronymique: "",
      editprenom: "",
      editgrade: "",
      editechelon: "",
      edittype_contrat: "",
      editau_tableau_emplois: "",
      editdate_debut: "",
      editdate_fin: "",
      editn1: "",
      editquotite_travail: "",
      editprojet1: "",
      editventilation1: "",
      editcout_ventile1: "",
      editprojet2: "",
      editventilation2: "",
      editcout_ventile2: "",
      editprojet3: "",
      editventilation3: "",
      editcout_ventile3: "",
      editprojet4: "",
      editventilation4: "",
      editcout_ventile4: "",
      editprojet5: "",
      editventilation5: "",
      editcout_ventile5: "",
    };
  },
  methods: {
    login() {
      this.axios
        .post(apiUrl + "/login", {
          name: "bonjour",
          password: this.password,
        })
        .then(() => {
          alert("Connection réussi");
          this.loginDialog = false;
          this.UpdateData();
        })
        .catch(() => {
          this.password = "";
          alert("Mauvais mot de passe");
        });
    },
    getTable() {
      this.axios
        .get(apiUrl)
        .then((response) => {
          console.log(response.data);
          this.table = response.data;
        })
        .catch(() => (this.loginDialog = true));
    },
    add() {
      this.table.forEach((i) => {
        this.table.push(i);
      });
    },
    printSelected() {
      console.log(this.selected);
    },
    UpdateData() {
      this.axios
        .get(apiUrl)
        .then((response) => (this.table = response.data))
        .catch(() => (this.loginDialog = true));
    },
    deleteSelected() {
      if (confirm("Etes vous sur de vouloir supprimer les rows séléctionné")) {
        this.axios
          .delete(apiUrl, { data: this.selected })
          .then(() => this.UpdateData())
          .catch(() => (this.loginDialog = true));
      }
    },
    deleteItem(item) {
      if (confirm("Voulez vous supprimer")) {
        this.axios
          .delete(apiUrl, { data: [item] })
          .then(() => this.UpdateData())
          .catch(() => (this.loginDialog = true));
      }
    },
    AddData() {
      this.axios
        .post(apiUrl, {
          // name: this.name,
          // taille: this.taille,
          // origine: this.origine,
          // age: this.age,
          matricule: this.matricule,
          nom_usuel: this.nom_usuel,
          nom_patronymique: this.nom_patronymique,
          prenom: this.prenom,
          grade: this.grade,
          echelon: this.echelon,
          type_contrat: this.type_contrat,
          au_tableau_emplois: this.au_tableau_emplois,
          date_debut: this.date_debut,
          date_fin: this.date_fin,
          n1: this.n1,
          quotite_travail: this.quotite_travail,
          projet1: this.projet1,
          ventilation1: this.ventilation1,
          cout_ventile1: this.cout_ventile1,
          projet2: this.projet2,
          ventilation2: this.ventilation2,
          cout_ventile2: this.cout_ventile2,
          projet3: this.projet3,
          ventilation3: this.ventilation3,
          cout_ventile3: this.cout_ventile3,
          projet4: this.projet4,
          ventilation4: this.ventilation4,
          cout_ventile4: this.cout_ventile4,
          projet5: this.projet5,
          ventilation5: this.ventilation5,
          cout_ventile5: this.cout_ventile5,
        })
        .then(() => {
          this.UpdateData();
          // this.name = null;
          // this.taille = null;
          // this.origine = null;
          // this.age = null;
          (this.matricule = null),
            (this.nom_usuel = null),
            (this.nom_patronymique = null),
            (this.prenom = null),
            (this.grade = null),
            (this.echelon = null),
            (this.type_contrat = null),
            (this.au_tableau_emplois = null),
            (this.date_debut = null),
            (this.date_fin = null),
            (this.n1 = null),
            (this.quotite_travail = null),
            (this.projet1 = null),
            (this.ventilation1 = null),
            (this.cout_ventile1 = null),
            (this.projet2 = null),
            (this.ventilation2 = null),
            (this.cout_ventile2 = null),
            (this.projet3 = null),
            (this.ventilation3 = null),
            (this.cout_ventile3 = null),
            (this.projet4 = null),
            (this.ventilation4 = null),
            (this.cout_ventile4 = null),
            (this.projet5 = null),
            (this.ventilation5 = null),
            (this.cout_ventile5 = null);
        })
        .catch(() => (this.loginDialog = true));
    },
    EditItem() {
      console.log(this.modifiingItem);
      console.log({
        // name: this.editName,
        // taille: this.editTaille,
        // origine: this.editOrigine,
        // age: this.editAge,
        matricule: this.editmatricule,
        nom_usuel: this.editnom_usuel,
        nom_patronymique: this.editnom_patronymique,
        prenom: this.editprenom,
        grade: this.editgrade,
        echelon: this.editechelon,
        type_contrat: this.edittype_contrat,
        au_tableau_emplois: this.editau_tableau_emplois,
        date_debut: this.editdate_debut,
        date_fin: this.editdate_fin,
        n1: this.editn1,
        quotite_travail: this.editquotite_travail,
        projet1: this.editprojet1,
        ventilation1: this.editventilation1,
        cout_ventile1: this.editcout_ventile1,
        projet2: this.editprojet2,
        ventilation2: this.editventilation2,
        cout_ventile2: this.editcout_ventile2,
        projet3: this.editprojet3,
        ventilation3: this.editventilation3,
        cout_ventile3: this.editcout_ventile3,
        projet4: this.editprojet4,
        ventilation4: this.editventilation4,
        cout_ventile4: this.editcout_ventile4,
        projet5: this.editprojet5,
        ventilation5: this.editventilation5,
        cout_ventile5: this.editcout_ventile5,
      });
      // Send
      // if (this.editName === '') this.editName = this.modifiingItem.name;
      // if (this.editTaille === '') this.editTaille = this.modifiingItem.taille;
      // if (this.editOrigine === '') this.editOrigine = this.modifiingItem.origine;
      // if (this.editAge === '') this.editAge = this.modifiingItem.age;
      this.axios
        .put(apiUrl, {
          old: this.modifiingItem,
          new: {
            $set: {
              matricule: this.editmatricule,
              nom_usuel: this.editnom_usuel,
              nom_patronymique: this.editnom_patronymique,
              prenom: this.editprenom,
              grade: this.editgrade,
              echelon: this.editechelon,
              type_contrat: this.edittype_contrat,
              au_tableau_emplois: this.editau_tableau_emplois,
              date_debut: this.editdate_debut,
              date_fin: this.editdate_fin,
              n1: this.editn1,
              quotite_travail: this.editquotite_travail,
              projet1: this.editprojet1,
              ventilation1: this.editventilation1,
              cout_ventile1: this.editcout_ventile1,
              projet2: this.editprojet2,
              ventilation2: this.editventilation2,
              cout_ventile2: this.editcout_ventile2,
              projet3: this.editprojet3,
              ventilation3: this.editventilation3,
              cout_ventile3: this.editcout_ventile3,
              projet4: this.editprojet4,
              ventilation4: this.editventilation4,
              cout_ventile4: this.editcout_ventile4,
              projet5: this.editprojet5,
              ventilation5: this.editventilation5,
              cout_ventile5: this.editcout_ventile5,
            },
          },
        })
        .then(() => this.UpdateData());
      // Clear formulaire
      // this.editName = null;
      // this.editTaille = null;
      // this.editOrigine = null;
      // this.editAge = null;
      (this.editmatricule = null),
        (this.editnom_usuel = null),
        (this.editnom_patronymique = null),
        (this.editprenom = null),
        (this.editgrade = null),
        (this.editechelon = null),
        (this.edittype_contrat = null),
        (this.editau_tableau_emplois = null),
        (this.editdate_debut = null),
        (this.editdate_fin = null),
        (this.editn1 = null),
        (this.editquotite_travail = null),
        (this.editprojet1 = null),
        (this.editventilation1 = null),
        (this.editcout_ventile1 = null),
        (this.editprojet2 = null),
        (this.editventilation2 = null),
        (this.editcout_ventile2 = null),
        (this.editprojet3 = null),
        (this.editventilation3 = null),
        (this.editcout_ventile3 = null),
        (this.editprojet4 = null),
        (this.editventilation4 = null),
        (this.editcout_ventile4 = null),
        (this.editprojet5 = null),
        (this.editventilation5 = null),
        (this.editcout_ventile5 = null);
    },
    syncEdited(val = this.modifiingItem) {
      // this.editName = val.name;
      // this.editTaille = val.taille;
      // this.editOrigine = val.origine;
      // this.editAge = val.age;
      (this.editmatricule = val.matricule),
        (this.editnom_usuel = val.nom_usuel),
        (this.editnom_patronymique = val.nom_patronymique),
        (this.editprenom = val.prenom),
        (this.editgrade = val.grade),
        (this.editechelon = val.echelon),
        (this.edittype_contrat = val.type_contrat),
        (this.editau_tableau_emplois = val.au_tableau_emplois),
        (this.editdate_debut = val.date_debut),
        (this.editdate_fin = val.date_fin),
        (this.editn1 = val.n1),
        (this.editquotite_travail = val.quotite_travail),
        (this.editprojet1 = val.projet1),
        (this.editventilation1 = val.ventilation1),
        (this.editcout_ventile1 = val.cout_ventile1),
        (this.editprojet2 = val.projet2),
        (this.editventilation2 = val.ventilation2),
        (this.editcout_ventile2 = val.cout_ventile2),
        (this.editprojet3 = val.projet3),
        (this.editventilation3 = val.ventilation3),
        (this.editcout_ventile3 = val.cout_ventile3),
        (this.editprojet4 = val.projet4),
        (this.editventilation4 = val.ventilation4),
        (this.editcout_ventile4 = val.cout_ventile4),
        (this.editprojet5 = val.projet5),
        (this.editventilation5 = val.ventilation5),
        (this.editcout_ventile5 = val.cout_ventile5);
    },
  },
  watch: {
    modifiingItem: function(val) {
      this.syncEdited(val);
    },
  },
  mounted: function() {
    this.axios.defaults.withCredentials = true;
    this.UpdateData();
  },
};
// new Vue({
//   el: '#app',
//   vuetify: new Vuetify(),
//   data () {
//     return {
//       headers: [
//         {
//           text: 'Dessert (100g serving)',
//           align: 'start',
//           sortable: false,
//           value: 'name',
//         },
//         { text: 'Calories', value: 'calories' },
//         { text: 'Fat (g)', value: 'fat' },
//         { text: 'Carbs (g)', value: 'carbs' },
//         { text: 'Protein (g)', value: 'protein' },
//         { text: 'Iron (%)', value: 'iron' },
//       ],
//       desserts: [
//         {
//           name: 'Frozen Yogurt',
//           calories: 159,
//           fat: 6.0,
//           carbs: 24,
//           protein: 4.0,
//           iron: '1%',
//         },
//         {
//           name: 'Ice cream sandwich',
//           calories: 237,
//           fat: 9.0,
//           carbs: 37,
//           protein: 4.3,
//           iron: '1%',
//         },
//         {
//           name: 'Eclair',
//           calories: 262,
//           fat: 16.0,
//           carbs: 23,
//           protein: 6.0,
//           iron: '7%',
//         },
//         {
//           name: 'Cupcake',
//           calories: 305,
//           fat: 3.7,
//           carbs: 67,
//           protein: 4.3,
//           iron: '8%',
//         },
//         {
//           name: 'Gingerbread',
//           calories: 356,
//           fat: 16.0,
//           carbs: 49,
//           protein: 3.9,
//           iron: '16%',
//         },
//         {
//           name: 'Jelly bean',
//           calories: 375,
//           fat: 0.0,
//           carbs: 94,
//           protein: 0.0,
//           iron: '0%',
//         },
//         {
//           name: 'Lollipop',
//           calories: 392,
//           fat: 0.2,
//           carbs: 98,
//           protein: 0,
//           iron: '2%',
//         },
//         {
//           name: 'Honeycomb',
//           calories: 408,
//           fat: 3.2,
//           carbs: 87,
//           protein: 6.5,
//           iron: '45%',
//         },
//         {
//           name: 'Donut',
//           calories: 452,
//           fat: 25.0,
//           carbs: 51,
//           protein: 4.9,
//           iron: '22%',
//         },
//         {
//           name: 'KitKat',
//           calories: 518,
//           fat: 26.0,
//           carbs: 65,
//           protein: 7,
//           iron: '6%',
//         },
//       ],
//     }
//   },
// })
</script>
